import { mediaMax } from "components/designV2/breakpoints";
import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const CustomerModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.lg}px;
`;

export const CustomerSection = styled.section`
  background: ${ColorV2.Blue7};
  border-radius: ${Radius.xl}px;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  padding: ${Spacing.lg}px;
`;

export const CustomerSectionHeader = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.md}px;
`;

export const CustomerSectionTitle = styled.h4`
  ${TypographyV2.h5}
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const CustomerSummaryGrid = styled.div`
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  ${mediaMax.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const CustomerSectionAction = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${Spacing.sm}px;
`;

export const CustomerProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
`;

export const CustomerProductRow = styled.div`
  background: ${ColorV2.White};
  border-radius: 16px;
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns:
    minmax(160px, 1.4fr) minmax(100px, 0.8fr) minmax(120px, 0.9fr)
    minmax(120px, 0.9fr) minmax(180px, 1.4fr);
  padding: ${Spacing.md}px;

  ${mediaMax.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  ${mediaMax.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const CustomerProductEmpty = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  padding: ${Spacing.sm}px 0;
`;

export const ServiceFormContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.lg}px;
`;

export const ServiceFormGrid = styled.div`
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${mediaMax.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const ServiceFormCompactGrid = styled.div`
  display: grid;
  gap: ${Spacing.md}px;
  grid-template-columns: repeat(2, minmax(0, 340px));

  ${mediaMax.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const ServiceFormDateGrid = styled.div`
  display: grid;
  gap: ${Spacing.sm}px;
  grid-template-columns: repeat(2, minmax(0, 320px));

  ${mediaMax.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const ServiceFormField = styled.div`
  min-width: 0;
`;

export const ServiceFormCheckboxRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
`;

export const ServiceFormActions = styled.div`
  display: flex;
  gap: ${Spacing.sm}px;
  justify-content: flex-end;
`;
